/**
 * Flatten an object with nested keys into a single level object with dot notation.
 * @param {Object} source The object to flatten
 * @param {String} [prefix=''] The prefix to use when flattening
 * @param {Object} [result={}] The object to store the flattened result
 * @return {Object} The flattened object
 */
export const flatten = (source = {}, prefix = '', result = {}) => {
  for (const key in source) {
    const value = source[key]
    const newKey = prefix ? `${prefix}.${key}` : key
    if (typeof value === 'object' && value !== null) {
      flatten(value, newKey, result)
    } else {
      if (newKey === 'extraReception.child') {
        console.warn({newKey, value})

      }
      result[newKey] = value
    }
  }
  return result
}

export const mergeI18nPatch = (patchDictionary) => {
  const mergeResult = {}

  patchDictionary.forEach(flatObject => {
    for (const key in flatObject) {
      const keys = key.split('.')
      let current = mergeResult

      keys.forEach((k, index) => {
        if (index === keys.length - 1) {
          current[k] = flatObject[key]
        } else {
          if (!current[k]) {
            current[k] = {}
          }
          current = current[k]
        }
      })
    }
  })

  return mergeResult
}

export default {
  mergeI18nPatch
}
